import { render } from "./TabComp.vue?vue&type=template&id=5ecbd8fe&scoped=true"
import script from "./TabComp.vue?vue&type=script&lang=js"
export * from "./TabComp.vue?vue&type=script&lang=js"

import "./TabComp.vue?vue&type=style&index=0&id=5ecbd8fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecbd8fe"]])

export default __exports__